import { render } from "./TabBar.vue?vue&type=template&id=a3f23566"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"
script.render = render

export default script